
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.22675 2.50383C6.24907 2.73048 5.34983 3.21458 4.6223 3.90592C3.89478 4.59726 3.36547 5.47065 3.08927 6.43551C2.81308 7.40037 2.80005 8.42155 3.05156 9.39314C3.30306 10.3647 3.80993 11.2513 4.51959 11.961C5.22926 12.6707 6.11586 13.1775 7.08745 13.429C8.05904 13.6805 9.08022 13.6675 10.0451 13.3913C11.0099 13.1151 11.8833 12.5858 12.5747 11.8583C13.266 11.1308 13.7501 10.2315 13.9768 9.25383C13.9768 9.08807 13.9109 8.9291 13.7937 8.81189C13.6765 8.69468 13.5175 8.62883 13.3518 8.62883H9.10175C8.77023 8.62883 8.45229 8.49714 8.21787 8.26272C7.98345 8.0283 7.85175 7.71036 7.85175 7.37883V3.00383C7.84399 2.92979 7.8216 2.85802 7.78589 2.79269C7.75018 2.72736 7.70185 2.66977 7.64371 2.62326C7.58557 2.57675 7.51878 2.54224 7.44721 2.52174C7.37563 2.50124 7.3007 2.49516 7.22675 2.50383Z","stroke":"#363636","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.97754 2.5C10.901 2.82515 11.7397 3.35331 12.432 4.04557C13.1242 4.73783 13.6524 5.57657 13.9775 6.5H10.7048C10.5119 6.5 10.3269 6.42338 10.1906 6.28699C10.0542 6.1506 9.97754 5.96561 9.97754 5.77273V2.5Z","stroke":"#363636","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    